import React from "react";
import FolieLayout from "./FolieLayout.jsx";
import SicherheitsstufenUebersicht from "./SicherheitsstufenUebersicht.jsx";

export default function Folie8Sicherheit({einstellungen}) {
    return (
        <FolieLayout
            nummer={9}
            titel="Wie sicher sind die Zahlen?"
            hilfe="Jede Zahl im Bereich trägt eine von fünf Sicherheitsstufen – von tatsächlich gemessen bis vorläufig angenommen."
            text={
                <p className="mb-0">
                    Nicht jede Zahl ist gleich sicher. Manche sind tatsächlich gemessen, manche stammen aus einer
                    Datei, manche sind von Hand gepflegt – und ein kleiner Rest ist bislang nur eine begründete
                    Annahme, weil die Messung noch fehlt. Genau das steht bei jeder Zahl im Bereich dabei, damit klar
                    ist, worauf man gerade schaut.
                </p>
            }
            leseHinweis='Jede Zahl im Bereich trägt eine dieser fünf farbigen Marken als Tooltip. Unten ein Vergleich: zwei Annahmen aus den Einstellungen gegen das, was die Mail-Recherche inzwischen tatsächlich gemessen hat.'
        >
            <SicherheitsstufenUebersicht einstellungen={einstellungen} />
        </FolieLayout>
    );
}
